import { render, staticRenderFns } from "./Fourth.vue?vue&type=template&id=c6cf3554&"
import script from "./Fourth.vue?vue&type=script&lang=js&"
export * from "./Fourth.vue?vue&type=script&lang=js&"
import style0 from "./Fourth.vue?vue&type=style&index=0&id=c6cf3554&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports